<template>
  <div class="modal__content">
    <div class="block-mo"></div>

    <p class="p modal__paragraph tac">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut</p>

    <div class="block-mo">
      <p class="p tac">Grid goes here</p>
    </div>

    <div class="modal__image"></div>
  </div>
</template>

<script>
// Vuex
// import { mapGetters, mapActions } from "vuex"

export default {
  name: `modal-base`

  // Components
  // Data
  // Computed
  // Methods
  // Watchers
  // Lifecycles
  // Filters
}
</script>
